module.exports = __webpack_public_path__ + "img/img-priority.86f54039.png";